import { object, string, number, InferType } from 'yup';
import * as Yup from 'yup';

const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const formikSetnewpass = {
    initialValues: {      
        newPassword: "",
        retypePassword: ""
    },
    validationSchema: Yup.object({
        newPassword: Yup.string()
            .required("Required Field")
            .min(8, "Password must be at least 8 characters long")
            .matches(/[a-z]/, "Password must contain at least one lowercase letter")
            .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
            .matches(/[0-9]/, "Password must contain at least one number")
            .matches(/[@$!%*?&#]/, "Password must contain at least one special character"),
        retypePassword: Yup.string()
            .required("Required Field")
            .oneOf([Yup.ref('newPassword')], "Passwords must match")
    })
};
